import MetaRobots from 'components/Basic/Head/MetaRobots/MetaRobots';

export default MetaRobots;
